import { accountSelect, AccountSelect } from "./select/AccountSelectComponent";
import { accountSearch, AccountSearch } from "./select/search/AccountSearchComponent";
import { accountDropDown, AccountDropDown } from "./select/drop-down/AccountDropDownComponent";
import { accountBrief, AccountBrief } from "./brief/AccountBriefComponent";
import { accountContractNotes, AccountContractNotes } from "./contract-notes/AccountContractNotesComponent";
import { bankTransactions, BankTransactions } from "./bank-transactions/BankTransactionsComponent";
import { accountTransactions, AccountTransactions } from "./account-transactions/AccountTransactionsComponent";
import { WorkflowService } from "./workflow/service/WorkflowService";
import { workflow, Workflow } from "./workflow/WorkflowComponent";
import { WorkflowTaskService } from "./workflow/wizard/WorkflowTaskService";
import { workflowTask, WorkflowTask } from "./workflow/wizard/WorkflowTaskComponent";
import {clientDetails, ClientDetails} from "./client-details/ClientDetailsComponent";

import {
    chessRegistrationDetail,
    ChessRegistrationDetail
} from "./chess-registration-details/ChessRegistrationDetailsComponent";
import {accountInformation, AccountInformation} from "./account-information/AccountInformationComponent";

export default function() {
    return angular.module("tfApp.account.components", [])
                  .component(AccountSelect, accountSelect())
                  .component(AccountSearch, accountSearch())
                  .component(AccountDropDown, accountDropDown())
                  .component(AccountBrief, accountBrief())
                  .component(AccountContractNotes, accountContractNotes())
                  .component(BankTransactions, bankTransactions())
                  .component(AccountTransactions, accountTransactions())
                  .component(ChessRegistrationDetail, chessRegistrationDetail())
                  .component(ClientDetails, clientDetails())
                  .component(AccountInformation, accountInformation())
                  .component(Workflow, workflow())
                  .component(WorkflowTask, workflowTask())
                  .service(WorkflowService.id, WorkflowService)
                  .service(WorkflowTaskService.id, WorkflowTaskService)
                  .name;
}
